$(document).ready(function () {
    let items = [];

    $.getJSON('/assets/colors.json', function (json) {
        items = json;
        // $("form#options input[type=submit]").click();
        let filteredResults1 = getBasicResults(1, items, true);
        if (filteredResults1.length > 0) {
            $('.bg-random').css('background-color', filteredResults1[0]['HEX']);
        }
    });

    function getBasicResults(qty, items, unique = false) {
        let filteredWords = [];
        let allWords = items.slice();
        let steps = allWords.length;
        let currentWord;
        let currentIndex;
        while (filteredWords.length < qty && steps > 0) {
            currentIndex = Math.floor((Math.random() * allWords.length));
            currentWord = allWords[currentIndex];
            filteredWords.push(currentWord);
        }
        return filteredWords;
    }
});
